<template>
  <div class="col-sm-12 col-md-5">
    <div class="dataTables_info" id="data-table-leave-approval-request_info" role="status" aria-live="polite">Showing {{ (currentPage - 1) * perPage +1}} to {{ (perPage * currentPage) > rows ? rows : (perPage * currentPage) }} of {{rows}} entries</div>
  </div>
</template>

<script>
export default {
  name: "PaginationInfo"
  ,props:{
    perPage:{
      type:Number,
      required:true
    },
    currentPage:{
      type:Number,
      required:true
    },
    rows:{
      type:Number,
      required:true
    }
  }
}
</script>